import React from "react";

import {
  CommonLabel,
  InputAndLabelWrapper,
  InputRowWrapper,
  YesOrNoRadioWrapper,
  GeneralInput,
  RadioInputWrapper,
  ErrorText,
  LabelAndInfoWrapper,
} from "../../styles";
import { useTranslation } from "react-i18next";
import { YES_NO_VAL } from "../utils";
import { useFormState } from "react-hook-form";

const { yes, no } = YES_NO_VAL;

function YesOrNoQuestion({
  yesVal = yes,
  noVal = no,
  name = "",
  label,
  register,
  handleChange = null,
  infoButton = null,
}) {
  const { t } = useTranslation();
  const nameRegister = register(name, { required: t("required") });
  const { errors } = useFormState();

  const error = errors?.[name]?.message;

  return (
    <InputRowWrapper>
      <InputAndLabelWrapper>
        <LabelAndInfoWrapper>
          <CommonLabel>
            {label}
            {infoButton}
          </CommonLabel>
        </LabelAndInfoWrapper>

        <YesOrNoRadioWrapper>
          <RadioInputWrapper>
            <GeneralInput
              type="radio"
              value={yesVal}
              id={`${name}-yes`}
              {...nameRegister}
              onChange={(e) => {
                nameRegister.onChange(e);
                if (typeof handleChange === "function") {
                  handleChange(e);
                }
              }}
            />
            <CommonLabel htmlFor={`${name}-yes`}>{t("yes")}</CommonLabel>
          </RadioInputWrapper>
          <ErrorText
            style={{ position: "absolute", top: "20px" }}
            error={error}
          >
            {error ?? "error placeholder"}
          </ErrorText>

          <RadioInputWrapper>
            <GeneralInput
              type="radio"
              value={noVal}
              id={`${name}-no`}
              {...nameRegister}
              onChange={(e) => {
                nameRegister.onChange(e);
                if (typeof handleChange === "function") {
                  handleChange(e);
                }
              }}
            />
            <CommonLabel htmlFor={`${name}-no`}>{t("no")}</CommonLabel>
          </RadioInputWrapper>
        </YesOrNoRadioWrapper>
      </InputAndLabelWrapper>
    </InputRowWrapper>
  );
}

export default YesOrNoQuestion;
